import AnswerBlank from './AnswerBlank';
import { WORKSHEET_CLASSES } from '../../constants/classNames';
import { getSiteEngine } from '../../data/sitePages';
import { describeFizzResult } from '../../utils/worksheetUtils';

const TICK = '✔';

/**
 * Predict, then test in the lab, whether each pair fizzes.
 */
export default function FizzOrNoFizzSheet({ worksheet, showAnswers }) {
  const engine = getSiteEngine();
  const rows = worksheet.pairs.map((pair) => {
    const [first, second] = pair.map((id) => engine.getSubstance(id));
    return { key: pair.join('+'), label: `${first.name} + ${second.name}`, ...describeFizzResult(engine.mix(...pair)) };
  });

  return (
    <section className={WORKSHEET_CLASSES.part}>
      <h2 className={WORKSHEET_CLASSES.partTitle}>{showAnswers ? 'What the lab shows' : 'Predict, then test'}</h2>
      <table className={WORKSHEET_CLASSES.table}>
        <thead>
          <tr>
            <th scope="col">Mix</th>
            <th scope="col" className={WORKSHEET_CLASSES.checkbox}>
              Fizz
            </th>
            <th scope="col" className={WORKSHEET_CLASSES.checkbox}>
              No fizz
            </th>
            <th scope="col">What really happened</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(({ key, label, fizzes, text }) => (
            <tr key={key}>
              <th scope="row">{label}</th>
              <td className={WORKSHEET_CLASSES.checkbox}>{showAnswers && fizzes ? TICK : ''}</td>
              <td className={WORKSHEET_CLASSES.checkbox}>{showAnswers && !fizzes ? TICK : ''}</td>
              <td>
                <AnswerBlank answer={text} showAnswer={showAnswers} isWide />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {!showAnswers && (
        <p className={WORKSHEET_CLASSES.footnote}>My score: ______ out of {rows.length} predictions right.</p>
      )}
    </section>
  );
}
